import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { RoleService } from './shared/role.service';
import { Role } from './shared/role';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Select2OptionData } from 'ng-select2';
import { Options } from 'select2'
import { CompanyService } from '../business/shared/company.service';
import { Company } from '../business/shared/company';
import { GenericResult } from '../globalClass/generic-class.model';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { isDate } from 'util';
import { AdmCategoryService } from '../globalService/adm-category.service';
import { VariablesService } from '../globalService/variables.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {

  dropdownEnabled = true;
  items:TreeviewItem[];
  values: number[];
  toEdit:any[];

  buttonClasses = [
    'btn-outline-primary',
    'btn-outline-secondary',
    'btn-outline-success',
    'btn-outline-danger',
    'btn-outline-warning',
    'btn-outline-info',
    'btn-outline-light',
    'btn-outline-dark'
  ];

  buttonClass = this.buttonClasses[0];



  add: boolean = true;
  edit:boolean = false;
  options: Options;
  multiCompanys: Array<Select2OptionData>;
  companys: Company[];
  tableWidget:any;
  datatable:any;
  listRole:Role[];
  roleForm: FormGroup;
  rolSelected:number = 0;
  arrayEstado = [{value:true,name:'Activo'},{value:false,name:'Inactivo'}];
  arrayTipoUsuario:any[]=[];


  testing(){
    
  }

  // config = TreeviewConfig.create({
  //   hasAllCheckBox: true,
  //   hasFilter: true,
  //   hasCollapseExpand: true,
  //   decoupleChildFromParent: true,
  //   maxHeight: 600
  // });
  
  constructor(private chRef:ChangeDetectorRef,
    private _roleService:RoleService,
    private _fb:FormBuilder,
    private companyService: CompanyService,
    private _toastr:ToastrService,
    public config:TreeviewConfig,
    private _categoriaService: AdmCategoryService,
    private variableService: VariablesService
    ) {
    this.config.decoupleChildFromParent = true;
    this.config.hasAllCheckBox = true;
    this.config.hasFilter = true;
    this.config.hasCollapseExpand = true;
    this.config.maxHeight = 600;
    this.getData();
    this.getModules();
  }

  getModules(){
    this._roleService.getModules().then((r:any[])=>{
      let temp = [];
      r.forEach(item => temp.push(new TreeviewItem(item,false)));
      this.items = temp;
    });
  }

  getData(){
    this._roleService.getRoles().then(
      r=> {
        this.listRole = r as Role[]
        this.initDatatable();
      }
    )
  }

  private initDatatable(): void {
    if ($.fn.dataTable.isDataTable('#dataTableRole')) {
      this.datatable.destroy();
    }
    this.chRef.detectChanges();
    const table: any = $('#dataTableRole');
    this.datatable = table.DataTable({
      responsive: true
    });
  }
  
  ngOnInit() {
    
    this.initMultipleSelectTest();
    this.add = false;
    this.createForm();
    this.loadCompany();
    this.variableService.getVariables().then(() => {
      this.loadSelect();
    });
  }

  onChangeAdd(action: boolean) {
    this.edit = !action;
    this.add = action;
  }

  changeAdd(action: boolean) {
    this.resetForm();
    this.edit = !action;
    this.add = action;
  }

  public onRowSelected(index: number) {
    
  }

  private onRowSelect(indexes: number[]): void {
    //this.rowSelected.emit(indexes[0])
  }

  createForm(){
    this.roleForm = this._fb.group({
      idSegRol:0,
      codigo:[null],
      nombre: [null,Validators.required],
      activo: [null,Validators.required],
      tipoUsuario:[null,Validators.required],
      companys:[null,Validators.required],
      SegEmpresaRol:null
    });
  }

  resetForm() {
    this.roleForm.reset();
  }

  onSubmit() {
    let formValues = Object.assign({},this.roleForm.value);
    formValues = Object.assign(formValues,{
      idSegRol:0,
      SegEmpresaRol:this.toArrayCompany(formValues,this.companys,false),
    });
    this.insertRecord(formValues);
  }

  cancel() {
    this.changeAdd(true);
    this.resetForm();
    //this.initDatatable();
  }

  insertRecord(formValues:any) {
    this._roleService.postRole(formValues).then(res => {
      let temp = res as any;
      if (temp.error) {
        this._toastr.error("ya existe un rol con este nombre");
      } else {
        this._toastr.success('Dato Insertado Satisfactoriamente', 'Role Register');
        this.changeAdd(false);
        this.getData();
        this.resetForm();
        $("#addrol").modal('hide');
      }
    }, e => { this._toastr.success('Algo paso', 'User Register'); console.error(e) });
  }

  update() {
    let update = true;
    let formValues = Object.assign({},this.roleForm.value);
    formValues = Object.assign(formValues,{
      empresas:this.toArrayCompany(formValues,this.companys,update).filter((f: any) => f.activo == 1).map((m: any) => m.idAdmEmpresa),
    });

    let request = {
      idSegRol: formValues.idSegRol,
      codigo: formValues.codigo,
      nombre: formValues.nombre,
      activo: formValues.activo,
      tipoUsuario: formValues.tipoUsuario,
      empresas: formValues.empresas
    };

    this._roleService.updateRol(request).then((r:GenericResult)=>{
      if(r.error){
        this._toastr.error("Un error ha ocurrido durante la actualziación de la información");
      }else{
        this._toastr.success("Actualizado con exito!");
        this.resetForm();
        this.edit = false;
        this.add = false;
        this.getData();
        $("#addrol").modal('hide');
      }
          });
  }


getidModuloRol(item,value){
  return (item.idSegRol == this.rolSelected && item.moduloIdModulo == value)
}



getArrayOfModules(isEdit?:boolean){
  let tempArr = [];
  if(isEdit === void 0){isEdit = false}
  if(isEdit){
    this.items.forEach(parent => {
      tempArr.push({idSegRol:this.rolSelected,activo:parent.checked,moduloIdModulo:parent.value,idSegModuloRol:this.toEdit.find(x=>this.getidModuloRol(x,parent.value)).idSegModuloRol});
      if(typeof(parent.children)!="undefined"){
        parent.children.forEach(child=>{
          tempArr.push({idSegRol:this.rolSelected,activo:child.checked,moduloIdModulo:child.value,idSegModuloRol:this.toEdit.find(x=>this.getidModuloRol(x,child.value)).idSegModuloRol});
          if(typeof(child.children)!="undefined"){
            child.children.forEach(grandchild=>{
              tempArr.push({idSegRol:this.rolSelected,activo:grandchild.checked,moduloIdModulo:grandchild.value,idSegModuloRol:this.toEdit.find(x=>this.getidModuloRol(x,grandchild.value)).idSegModuloRol});
            });
          }
        })
      }
    });
  }else{
    this.items.forEach(parent => {
      tempArr.push({idSegRol:this.rolSelected,activo:parent.checked,moduloIdModulo:parent.value});
      if(typeof(parent.children)!="undefined"){
        parent.children.forEach(child=>{
          tempArr.push({idSegRol:this.rolSelected,activo:child.checked,moduloIdModulo:child.value});
          if(typeof(child.children)!="undefined"){
            child.children.forEach(grandchild=>{
              tempArr.push({idSegRol:this.rolSelected,activo:grandchild.checked,moduloIdModulo:grandchild.value});
            });
          }
        })
      }
    });
  }
  return tempArr;
}


  saveModules(){
    if(this.rolSelected != 0){
      let tempListForm
        tempListForm = this.getArrayOfModules(this.toEdit.length > 0);
        this._roleService.saveModules(tempListForm).then((r:GenericResult)=>{
          if(r.error){
            this._toastr.error("Un error ha ocurrido durante la asignación de los modulos");
          }else{
            this._toastr.success("Modulos Registrados");
            //$("#"+this.rolSelected).value.cheked = false
            this.rolSelected = 0;
            this.toEdit = [];
            this.getModules();
          }
        });
    }else{
      this._toastr.warning("Debe Seleccionar el rol al cual se le asignaran los modulos");
    }
  }

  eneableOrDisable(idRol:number){
    this.rolSelected = idRol;
    this.toEdit = [];
    this._roleService.getModulesByRol(idRol).then((r:any)=>{
      let temp = [];
      if(typeof(r.treeView)!="undefined"){
        let tree = r.treeView;
        tree.forEach(item => temp.push(new TreeviewItem(item,false)));
        this.toEdit = r.toEdit;
      }else{
        let tree = r;
        tree.forEach(item => temp.push(new TreeviewItem(item)));
      }
      this.items = [];
      this.items = temp;
    });
  }

  editRol(idRol:number){
    debugger;
    this.resetForm();
    this.edit = true;
    this.getRoleById(idRol);
  }

  getRoleById(idRol:number){
    this._roleService.getRoleById(idRol).then(
      (r:any)=>{
       this.roleForm.patchValue({
         idSegRol:r.idSegRol,
         nombre:r.nombre,
         activo:r.activo,
         tipoUsuario:r.tipoUsuario, ///////////////////////////////////////////////TODO:Tengo mis dudas
         codigo:r.codigo,
         companys:this.converToArrayCompany(r.segEmpresaRol),
         SegEmpresaRol:r.segEmpresaRol
       });
      }
    );
  }

  converToArrayCompany(array: any) {
    if (typeof (array) != 'undefined') {
      let temp = array.map((e) => (e.activo)?e.idAdmEmpresa.toString():null);
      return temp;
    } else {
      return null;
    }
  }

  loadCompany() {
    this.companyService.getCompany().then(r => { this.companys = r as Company[]; this.loadCompanysSelectMultiple(r);});
  }

  loadCompanysSelectMultiple(objectData: any) {
    if (objectData != null) {
      this.multiCompanys = [];
      for (var i = 0; i < objectData.length; i++) {
        this.multiCompanys.push({ id: objectData[i].idAdmEmpresa, text: objectData[i].nombre });
      }
    }
  }

  toArrayCompany(valueSubmit, companys, update) {
    let temp = [];
    if (update && valueSubmit.SegEmpresaRol.length > 0) {
      valueSubmit.SegEmpresaRol.forEach((ele) => {
        temp.push({ idSegEmpresaRol:ele.idSegEmpresaRol,idSegRol:valueSubmit.idSegRol, idAdmEmpresa: ele.idAdmEmpresa, activo: valueSubmit.companys.includes(ele.idAdmEmpresa.toString()) });
      });

      valueSubmit.companys.forEach((ele) => {
        let company = companys.find(f => f.idAdmEmpresa.toString() == ele);
        let companyExists = temp.find(f => f.idAdmEmpresa.toString() == ele);
        if(company != undefined && companyExists == undefined)
        {
          temp.push( 
          { 
            idSegRol:valueSubmit.idSegRol, 
            idAdmEmpresa: company.idAdmEmpresa, 
            activo: true
          });
        }
        if(company == undefined && companyExists != undefined)
        {
          companyExists.activo = false; 
        }
      });
    } else {
      companys.forEach((ele) => {
        temp.push({ idAdmEmpresa: ele.idAdmEmpresa, activo: valueSubmit.companys.includes(ele.idAdmEmpresa.toString()) });
      });
    }
    return temp;
  }

  loadSelect() {
    this._categoriaService.getListOfCategory(this.variableService.data.tipoCategoria.tipoUsuarioRol).then(r => this.arrayTipoUsuario = r);
  }

  initMultipleSelectTest() {
    this.options = {
      width: '300',
      multiple: true,
      tags: true
    };
  }



  checkCompanys(){
    let values = new Array();
    for (let i = 0; i < this.multiCompanys.length; i++) {
      values.push(`${this.multiCompanys[i].id}`);
    }
    this.roleForm.patchValue({ companys: values });
  }

  unCheckCompanys(){
    this.roleForm.patchValue({ companys: null });
  }

  checkAllCompanys(event) {
    debugger;
    if (event.currentTarget.checked) {
      this.checkCompanys();
    } else {
      this.unCheckCompanys();
    }
  }

  onSelectedChange(event){
    alert("onSelectedChanged");
  }

  onFilterChange(value:string){
    
  }

  checkAll(){
    this.config.hasAllCheckBox = !this.config.hasAllCheckBox;
  }


  // openModalAddRole(idTicket:number){
  //   this.idFlujoTicket = idTicket;
  //   this._workflowservice.getFilesByFlujoTicket(idTicket).then(
  //     (r:GenericResult)=>{
  //       if(r.error){
  //         this._alertServices.messageError(r.message);
  //       }else{
  //         if ($.fn.dataTable.isDataTable('#tableFiles')) {
  //           this.datatable.destroy();
  //         }
  //         this.filesFlowTicket = r.result
  //         this.chRef.detectChanges();
  //         const tableFiles: any = $('#tableFiles');
  //         this.datatable = tableFiles.DataTable({
  //           responsive: true
  //         });
  //       }
  //     }
  //   )
  // }
}
